import * as Yup from "yup";

const grupoProdutosValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
});

export default grupoProdutosValidator;
